import styled from 'styled-components';

const SidebarContent = styled.div`
  &.fade-exit {
    position: absolute;
    top: 50px;
    left: 30px;
    right: 30px;
    transition: opacity 0.4s ease-in;
  }
  &.fade-exit-active {
    opacity: 0;
  }
  &.fade-enter {
    transition: opacity 0.4s ease-in;
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
  }
`;

export default SidebarContent;



// WEBPACK FOOTER //
// ./src/pages/Login/SidebarContent.js